import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Only track on the live production domain. Preview/dev/localhost never send hits.
function isProductionHost() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h === "wearspray.com" || h === "www.wearspray.com";
}

let scriptLoaded = false;

function loadGA(id) {
  if (scriptLoaded || !id) return;
  scriptLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  // We fire page_view manually on route change (SPA), so disable auto page_view.
  gtag("config", id, { send_page_view: false });
}

// Loads Google Analytics (GA4) and records a page view on every route change.
export default function Analytics() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!GA_ID || !isProductionHost()) return;
    loadGA(GA_ID);
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname]);

  return null;
}
